<template lang="pug">
    v-container(class="fill-height pa-0 ma-0" fluid grid-list-sm)
        edit-dialog(ref="refEditDialog" :socket-id="socketId" @saved="onNewRoomSaved" @wrong="onSomethingWrong")
        edit-dialog2(ref="refEditDialog2" :socket-id="socketId" @saved="onNewRoomSaved" @wrong="onSomethingWrong")
        mention-dialog(ref="refMentionDialog")
        rename-dialog(ref="refRenameDialog" @save="onSaveRename")
        chat-room-finder(ref="refChatRoomFinder" @new="onNewChatRoom" @select="onSelectFromFinder" @wrong="onSomethingWrong")
        v-overlay(:value="showOverlay")
            v-progress-circular(indeterminate size="64")
        v-layout(row)
            v-flex(md4 lg3 class="white" tag="perfect-scrollbar").chat-box.hidden-sm-and-down
                chat-channel(:channels="channels"
                    :sub-channels="subChannels"
                    :rooms="activeRooms"
                    :histories="histories"

                    :current-channel-id="currentChannelId"
                    :current-sub-channel-id="currentSubChannelId"
                    :current-room-id="currentRoomId"

                    :current-sub-channel="currentSubChannel"
                    :current-channel="currentChannel"
                    :current-room="currentRoom"
                    :can-delete-room="user.perm_delete_chat_room"
                    :can-rename-room="user.perm_create_chat_room"

                    @channel="onSelectChannel"
                    @sub-channel="onSelectSubChanel"
                    @room="onSelectRoom"
                    @history="onSelectRoom"
                    @find="onFindChatRoom"
                    @delete-room="onDeleteRoom"
                    @edit-room="onEditRoom")
            v-flex(md8 lg9)
                chat-window(:message.sync="message"
                    :conversations="sortedConversations"
                    :current-room="currentRoom"
                    :current-room-id="currentRoomId"
                    :socket-id="socketId"
                    :can-edit-room="user.perm_create_chat_room"
                    :mention-count="mentionUserIds.length"
                    :mention-html="mentionUserHtml"
                    :mention-ids="mentionUserIds"

                    @image="onShowImage"
                    @new-message="onNewMessage"
                    @open-file="onOpenFolderOrSheet"
                    @edit-room="onEditRoom"
                    @complete-case="onCompleteCase"
                    @mention="onMention")
        image-viewer(ref="refImageViewer" @download="onDownloadImage")
</template>

<script>
import chat from "../mixins/chat";
import general from "../mixins/general";
import echo from "../mixins/echo";
import auth from "../mixins/auth";
import ChatChannel from "../components/chat/ChatChannel";
import ChatWindow from "../components/chat/ChatWindow";
import { get, sync, call } from "vuex-pathify";
import _ from "lodash";
import ImageViewer from "../components/core/ImageViewer";
import ChatRoomFinder from "../components/chat/ChatRoomFinder";
import EditDialog from "../components/chat/EditDialog";
import EditDialog2 from "../components/chat/EditDialog2";
import { fetchChatFolder } from "../services";
import RenameDialog from "../components/chat/RenameDialog";
import MentionDialog from "../components/chat/MentionDialog";
import useEventBus from "../mixins/useEventBus";
import { Pipes } from "../event";

export default {
  name: "Chat",
  components: {
    MentionDialog,
    RenameDialog,
    ChatRoomFinder,
    ChatWindow,
    ChatChannel,
    ImageViewer,
    EditDialog,
    EditDialog2
  },
  mixins: [general, echo, auth, chat, useEventBus],
  computed: {
    message: sync("chats/message"),
    socketId: sync("chats/socketId"),
    mentionUserIds: sync("chats/mentionUserIds"),
    mentionUserHtml: sync("chats/mentionUserHtml"),
    currentChannelId: get("chats/currentChannelId"),
    currentSubChannelId: get("chats/currentSubChannelId"),
    currentRoomId: get("chats/currentRoomId")
  },
  methods: {
    changeChannelId: call("chats/changeChannelId"),
    changeSubChannelId: call("chats/changeSubChannelId"),
    changeRoomId: call("chats/changeCurrentRoomId"),
    setOnlineUsersIds: call("users/setOnlineUsersIds"),

    onCanFillConversation() {
      return true;
    },
    onOpenFolderOrSheet(room) {
      this.fileOpening = true;
      this.axios
        .get(`rooms/${room.id}`)
        .then(res => {
          const room = res.data.data;
          if (room.sheet) {
            const users = _.get(room.sheet, "users", []);
            const idx = _.findIndex(users, u => (u.id = this.user.id));
            if (idx > -1) {
              this.$store
                .set("operationSheet/fromChat", {
                  sheetId: room.sheet.id,
                  channelId: room.sub_channel.channel.id,
                  subChannelId: room.sub_channel.id,
                  roomId: room.id,
                  data: {
                    channel: { ...this.currentChannel },
                    subChannel: { ...this.currentSubChannel },
                    room: { ...this.currentRoom }
                  }
                })
                .then(() => {
                  this.$router.push({ name: "sheet.index" });
                });
            } else {
              this.$toasted.error("Permission Deny for Open Spreadsheet", {
                icon: "mood_bad",
                className: "error"
              });
            }
          } else if (room.file) {
            fetchChatFolder(room.file.id).then(async data => {
              if (data.accessible) {
                await this.$store.set("operationCalendar/fromChat", data);
                this.$router.push({ name: "calendar.index" });
              } else {
                this.$toasted.error(
                  this.$t("general.permissionFailed.createReadFolder"),
                  {
                    icon: "mood_bad",
                    className: "error"
                  }
                );
              }
            });
          }
        })
        .finally(() => (this.fileOpening = false));
    }
  },
  created() {
    this.eventListeners.push({
      name: Pipes.notify.openChatRoom,
      callback: async data => {
        await this.$store.set("chats/currentChannelId", data.channel_id);
        await this.$store.set("chats/currentSubChannelId", data.sub_channel_id);
        await this.$store.set("chats/currentRoomId", data.room_id);
        await this.fetchAllChannels();
      }
    });
  },
  mounted() {
    this.fetchAllChannels();
  }
};
</script>

<style scoped lang="scss">
.chat-box {
  height: calc(100vh - 65px);
}
</style>
